import { apiClient } from "../service/tekkr-service";
import { ClientInferResponseBody } from "@ts-rest/core";
import { apiContract } from "tekkr-common/dist/model/api/api.contract";
import _ from "lodash";
import { useQuery } from "@tanstack/react-query";

export function useGetOrgQuery() {
    return useQuery({
        queryKey: ["org"],
        queryFn: async () => {
            const response = await apiClient.getOrg();
            const body = response.body as ClientInferResponseBody<typeof apiContract.getOrg, 200>;
            body.users = _.sortBy(body.users, "name");
            return body;
        },
    });
}
